import { ScaleLinear, ScaleLogarithmic, type ScaleSymLog } from 'd3-scale';

import { isLogScale } from './detect-scale.js';
import { replaceZeroWithEpsilon } from './replace-zero.js';

/**
 * Changes all zero values to number Epsilon because y-scale doesn't support 0.
 *
 * @param scale - given timeseries y scale
 * @param value - given datapoint value
 *
 * @returns sanitized value
 */
export function sanitizeZeroValues(
  scale:
    | ScaleLinear<number, number>
    | ScaleLogarithmic<number, number>
    | ScaleSymLog<number, number>,
  value: number,
): number {
  if (isLogScale(scale)) {
    return scale(replaceZeroWithEpsilon(value)) ?? Number.EPSILON;
  }

  return scale(value) ?? 0;
}
